import { ReactNode } from "react";

interface PageTransitionProps {
  children: ReactNode;
}

// Removed framer-motion animation to prevent CLS (Cumulative Layout Shift)
// Elements now render immediately at their final position
export function PageTransition({ children }: PageTransitionProps) {
  return <>{children}</>;
}
